module.exports = __webpack_public_path__ + "static/media/title-map.ed8566e6.svg";